import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import Usuario from '../../../Utils/Usuario';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import update from 'immutability-helper';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import ModalAlteracoes from '../../../Components/Modal-Alteracoes/Modal-Alteracoes';
import Session from '../../../Utils/Session';
import VideosEpisodes from '../../../Components/Videos-Episodes/Videos-Episodes';
import qs from 'qs';
import Pagination from 'rc-pagination';



class VideosProgramDetails extends Component {

    constructor(props) {
        super(props);

        this.editarEpisodio = this.editarEpisodio.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.carregaEpisodios = this.carregaEpisodios.bind(this);
        this.novoEpisodio = this.novoEpisodio.bind(this);
        this.mudaStatusEpisodio = this.mudaStatusEpisodio.bind(this);
        this.mudaStatusPrograma = this.mudaStatusPrograma.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.salvarPrograma = this.salvarPrograma.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.voltar = this.voltar.bind(this);
        this.refreshTableEpisodes = this.refreshTableEpisodes.bind(this);
        this.inicializaParametros = this.inicializaParametros.bind(this);
        this.onChangePage = this.onChangePage.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            openModal: false,
            idVideoPrograma: this.props.match.params.idVideoPrograma,
            nomePrograma: '',
            descricaoPrograma: '',
            urlImagem: '',
            isLoadingEpisodios: false,
            isLoadingPrograma: false,
            isLoadingStatusPrograma: false,
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "habilitar",
            sucessoAlteracao: false,
            temAlteracao: false,
            listaEpisodios: [],
            infosPrograma: {},
            hasError: false,
            errorMessage: '',
            modalAlteracoes: false,
        }
    }

    componentDidMount() {
        this.carregaEpisodios();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.carregaEpisodios();
        }
    }

    excluirEpisodio(idVideoEpisodio) {
        alert(`Excluir episódio ${idVideoEpisodio}`)
    }

    mudaStatusEpisodio(metodo, idVideoEpisodio) {
        const _idVideoPrograma = this.props.match.params.idVideoPrograma;
        const _index = this.state.listaEpisodios.findIndex(item => item.idVideoEpisodio === idVideoEpisodio);
        this.setState({ listaEpisodios: update(this.state.listaEpisodios, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/videos/${_idVideoPrograma}/episodios/${idVideoEpisodio}/${metodo}`).then(response => {
            this.carregaEpisodios();
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingEpisodios: false,
            listaEpisodios: update(this.state.listaEpisodios, { [_index]: { loading: { $set: false } } })
        }));
    }

    mudaStatusPrograma() {
        const _idVideoPrograma = this.props.match.params.idVideoPrograma
        axios.put(this.Configurations.apiBasePath + `/videos/${_idVideoPrograma}/${this.state.metodoStatusPublicacao}`)
            .then(response => {
                this.carregaInfosPrograma(_idVideoPrograma);
            }).catch(this.handleError)
            .finally(() => {
                this.toggleStatusPublicacao();

            });
    }

    confirmaStatusPublicacao(_idVideoPrograma, _metodo) {
        this.toggleStatusPublicacao();
        this.setState({
            idVideoPrograma: _idVideoPrograma,
            metodoStatusPublicacao: _metodo
        })
    }

    componentWillMount() {
        const _idVideoPrograma = this.props.match.params.idVideoPrograma;
        let _permissoes = [1, 4, 10, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!found && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' })
        } else {
            this.inicializaParametros();
            this.carregaInfosPrograma(_idVideoPrograma);
            this.setState({ permissaoEdicaoVideo: found })
        }
    }

    inicializaParametros() {
        const _parametros = [];
        _parametros.push(`limite=${Session.getParametrosListaEpisodios["videos"].limite}`);
        _parametros.push(`pagina=${Session.getParametrosListaEpisodios["videos"].pagina}`);
        this.setState({
            queryParametros: _parametros,
            pagina: Session.getParametrosListaEpisodios["videos"].pagina,
            limite: Session.getParametrosListaEpisodios["videos"].limite,
        });
    }

    carregaEpisodios() {
        this.setState({ isLoadingEpisodios: true })
        const _idVideoPrograma = this.props.match.params.idVideoPrograma
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10),
            pagina = parseInt(values["?pagina"], 10);
        axios.get(this.Configurations.apiBasePath + `/videos/${_idVideoPrograma}/episodios?pagina=${pagina}&limite=${limite}`).then(response => {
            this.setState({
                listaEpisodios: response.data.videosEpisodios,
                paginasEpisodios: response.data.paginacao.totalPaginas,
                limite: limite,
                pagina: pagina
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEpisodios: false }));
    }


    refreshTableEpisodes() {
        this.carregaEpisodios();
    }

    carregaInfosPrograma(idVideoPrograma) {
        this.setState({ isLoadingPrograma: true });
        axios.get(this.Configurations.apiBasePath + `/videos/programas/${idVideoPrograma}`).then(response => {
            const _programa = response.data.data[0];
            this.setState({
                infosPrograma: _programa,
                nomePrograma: _programa.nome,
                descricaoPrograma: _programa.descricao,
                urlImagem: _programa.imagem
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoadingPrograma: false }));
    }

    editarEpisodio(_episodio) {
        this.props.history.push(`${this.props.match.url}/${_episodio.idVideoEpisodio}`)
    }

    novoEpisodio() {
        this.props.history.push(`${this.props.match.url}/novo-episodio`)
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    salvarPrograma() {
        this.setState({ isLoadingPrograma: true })
        const _idVideoPrograma = this.props.match.params.idVideoPrograma,
            { nomePrograma, descricaoPrograma, urlImagem } = this.state,
            _salvarPrograma = {
                nome: nomePrograma,
                descricao: descricaoPrograma,
                imagem: urlImagem
            };
        axios.put(this.Configurations.apiBasePath + `/videos/programas/${_idVideoPrograma}`, _salvarPrograma).then(response => {
            this.setState({ sucessoAlteracao: true, temAlteracao: false })
            this.carregaInfosPrograma(_idVideoPrograma);
        }).catch(this.handleError).finally(() => this.setState({ isLoadingPrograma: false }));
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value, temAlteracao: true })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    voltar() {
        this.state.temAlteracao ? this.toggleModalAlteracoes() : window.history.go(-1)
    }

    onChangePage(page) {

        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/multimidia/videos/${this.props.match.params.idVideoPrograma}`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }

    render() {
        return (
            <div className="row episodes-list">
                <div className={`col-12`}>
                    {this.state.isLoadingEpisodios || this.state.isLoadingPrograma ? (
                        <div className="row no-gutters">
                            <div className="col-12 text-center py-5">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className="row no-gutters">
                            <div className="col-12">
                                <div className="row no-gutters align-items-center">
                                    <div className="col-12 col-lg-8 text-center text-lg-left">
                                        <h2 className="title-1 d-none d-lg-block">Vídeos - Programa "{this.state.infosPrograma.nome}"</h2>
                                        <h5 className="d-lg-none">{this.state.infosPrograma.nome}</h5>
                                    </div>
                                    <div className="col-12 col-lg-4 text-center text-lg-right">
                                        <div className="row no-gutters">
                                            <div className="col py-2 py-lg-0">
                                                <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isLoadingPrograma ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card rounded my-2">
                                        <div className="card-header">
                                            <p className="m-0">Informações do Programa</p>
                                        </div>
                                        <div className="card-body">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col-12 col-lg-6">
                                                    <fieldset disabled={!this.state.permissaoEdicaoVideo}>
                                                        <div className="row no-gutters">
                                                            <div className="col-12 px-1 py-1">
                                                                <label>Nome do programa</label>
                                                                <input autoComplete="off" name="nomePrograma" className="form-control input-edicao" type="text" value={this.state.nomePrograma} onChange={this.handleOnChange} />
                                                            </div>
                                                            <div className="col-12 px-1 py-1">
                                                                <label>Descrição do programa</label>
                                                                <input autoComplete="off" name="descricaoPrograma" className="form-control input-edicao" type="text" value={this.state.descricaoPrograma} onChange={this.handleOnChange} />
                                                            </div>
                                                            <div className="col-12 px-1 py-1">
                                                                <label>Url para imagem de capa</label>
                                                                <input autoComplete="off" name="urlImagem" className="form-control input-edicao" type="text" value={this.state.urlImagem} onChange={this.handleOnChange} />
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                </div>
                                                <div className="col-12 col-lg-6">
                                                    <div className="row no-gutters">
                                                        <div className="col-12 py-1">
                                                            <div className="row no-gutters align-items-center">
                                                                <div className="offset-lg-2 col-lg-8 col-12 text-center py-3">
                                                                    <div className="div-img-capa" style={{ backgroundImage: `url(${this.state.urlImagem})` }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-lg-12 py-3 text-center text-lg-right">
                                                    {this.state.isLoadingPrograma ? (
                                                        <div className="spinner-border text-primary" role="status" />
                                                    ) : (
                                                        <>
                                                            {this.state.sucessoAlteracao && !this.state.temAlteracao && (
                                                                <span className="text-success mr-3"><i>Alterações salvas com sucesso.</i></span>
                                                            )}
                                                            {this.state.temAlteracao && (
                                                                <span className="text-danger mr-3"><i>As alterações ainda não foram salvas.</i></span>
                                                            )}
                                                            {this.state.permissaoEdicaoVideo && (
                                                                <button onClick={this.salvarPrograma} disabled={this.state.nomePrograma.trim() === '' || !this.state.temAlteracao} className="btn btn-outline-success">salvar alterações</button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="row no-gutters">
                                    <div className="col-12 pt-4 pb-3 text-center">
                                        <h5 className="m-0">Lista de episódios</h5>
                                    </div>
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row no-gutters align-items-center pb-lg-3">
                                                    <div className="col-12 col-lg-4 py-lg-0 text-center text-lg-left">
                                                        <h6 className="m-0">Status: <span className={`badge badge-${this.state.infosPrograma.habilitado ? 'success' : 'secondary badge-opacity'}`}>{this.state.infosPrograma.habilitado ? "Habilitado" : "Desabilitado"}</span></h6>
                                                    </div>

                                                    <div className="col-12 col-lg-4">
                                                        <div className="row no-gutters">
                                                            {this.state.infosPrograma.habilitado ? (
                                                                <div className="col-12 py-3 py-lg-0 text-center">
                                                                    {this.state.permissaoEdicaoVideo && (
                                                                        <button onClick={() => this.confirmaStatusPublicacao(this.state.idVideoPrograma, "desabilitar")} className="btn btn-outline-danger">desabilitar programa</button>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="col-12 py-3 py-lg-0 text-center">
                                                                    {this.state.permissaoEdicaoVideo && (
                                                                        <button onClick={() => this.confirmaStatusPublicacao(this.state.idVideoPrograma, "habilitar")} className="btn btn-outline-info">habilitar programa</button>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-lg-4 pb-3 py-lg-2 text-center">
                                                        {this.state.permissaoEdicaoVideo && (
                                                            <button onClick={this.novoEpisodio} className="btn btn-outline-success">novo episódio</button>
                                                        )}
                                                    </div>
                                                </div>
                                                {this.state.isLoadingEpisodios ? (
                                                    <div className="col-12 text-center px-3 py-5">
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                ) : (
                                                    <div className="col-12">
                                                        <div className="row lista-episodios">
                                                            {!!this.state.listaEpisodios && this.state.listaEpisodios.map((item, index) => {
                                                                return (
                                                                    <div className="col-12 py-2" key={index}>
                                                                        <VideosEpisodes
                                                                            item={item}
                                                                            mudaStatusEpisodio={this.mudaStatusEpisodio}
                                                                            history={this.props.history}
                                                                            match={this.props.match}
                                                                            permissaoEdicaoVideo={this.state.permissaoEdicaoVideo}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.isLoadingEpisodios && this.state.listaEpisodios && this.state.listaEpisodios.length > 0 && (
                                        <div className="col-12 mt-2 px-0">
                                            <div className="paginacao-episodios">
                                                <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasEpisodios * this.state.limite} pageSize={this.state.limite} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status do Programa</ModalHeader>
                    <ModalBody>
                        {this.state.metodoStatusPublicacao === 'habilitar' ? (
                            <p className="m-0">{`Deseja confirmar a habilitação do programa ${this.state.nomePrograma}?`}</p>
                        ) : (
                            <p className="m-0">{`Deseja desabilitar o programa ${this.state.nomePrograma}?`}</p>
                        )}

                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusPrograma ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusPrograma} color={`${this.state.metodoStatusPublicacao === 'habilitar' ? `success` : `danger`}`} onClick={this.mudaStatusPrograma}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
                <ModalAlteracoes
                    isOpen={this.state.modalAlteracoes}
                    toggle={this.toggleModalAlteracoes}
                />
            </div>
        )
    }
}

export default VideosProgramDetails;
